import { toDataURL } from "qrcode";
import React from "react";

export interface QRCodeProps {
    value: string;
    size: number;
    style?: React.CSSProperties;
    className?: string;
}

export default function QRCode(props: QRCodeProps) {
    let dataUrl: string | undefined = undefined;
    const { value, size = 160, style, className } = props;

    toDataURL(value, { width: size, margin: 0 }, (err, url) => {
        if (err) {
            console.error(err);
            return;
        }
        dataUrl = url;
    });

    return <img className={className} style={style} src={dataUrl} />;
}